import React from 'react'
// libs
import styled from 'styled-components'
// hooks
import { useMediaQuery } from '@mui/material'
// components
import { Button, BUTTON_LAYOUTS, PopoverModal } from 'components/UI'
// constants
import { SCREEN_SIZE } from 'constants/screenSize'
// view components
import PlanVisibilityMenu from 'components/PageComponents/Plans/Edit/components/PlanVisibilityMenu'
// themes
import { colors } from 'themes'
//icons
import Visibility from '@mui/icons-material/Visibility'

const IconWrapper = styled.div`
  align-items: center;
  background-color: ${colors.darkBlue400};
  border-radius: 22px;
  display: flex;
  min-height: 40px;
  justify-content: center;
  min-width: 40px;
  cursor: pointer;

  path {
    fill: ${colors.white};
  }
`

// constants
const BUTTON_STYLE = {
  color: colors.purple300,
  height: '40px'
}

const MODAL_PROPS = {
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'center' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'center' as const
  },
  PaperProps: {
    style: { marginTop: '24px' }
  }
}

interface Props {
  entity: Record<string, any>
  disabled?: boolean
  entityType: string
  onSetVisibility: (input: Record<'private', boolean>) => Promise<void>
}

const ChangeVisibilityButton: React.FC<Props> = ({ entity, disabled, entityType, onSetVisibility }) => {
  const [visibility, setVisibility] = React.useState(entity?.private ? 'Private' : 'Organisation')

  const isTablet = useMediaQuery(SCREEN_SIZE.TABLET)

  let trigger = (
    <Button
      shadowLess
      layout={BUTTON_LAYOUTS.DARK_BLUE}
      type='button'
      style={BUTTON_STYLE}
      disabled={disabled}
      data-testid='change-visibility-trigger'>
      {visibility.toUpperCase()}
    </Button>
  )

  if (isTablet) {
    trigger = (
      <IconWrapper data-testid='change-visibility-trigger'>
        <Visibility />
      </IconWrapper>
    )
  }

  const handleSetVisibility = (value: boolean) => {
    setVisibility(value ? 'Private' : 'Organisation')

    onSetVisibility({
      private: value
    })
  }

  return (
    <PopoverModal {...MODAL_PROPS} trigger={trigger}>
      {({ closePopup }) => (
        <PlanVisibilityMenu
          visibility={visibility}
          closePopup={closePopup}
          entityType={entityType}
          handleSetVisibility={handleSetVisibility}
        />
      )}
    </PopoverModal>
  )
}

export default ChangeVisibilityButton
